// Owner: library (plan §9.8). `/library/new?type=page|deck|document_template|dashboard&parent=` creates
// an artefact and opens its editor (the command bar's "New …" items and any link use it).
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LIBRARY_KINDS } from '@dataroom/core/search-enums';
import { LibraryNew } from '../../../features/library/LibraryNew';

export const Route = createFileRoute('/_app/library/new')({
  validateSearch: z.object({
    // Folders are named in a dialog in the Library, not created by a link.
    type: z.enum(LIBRARY_KINDS).exclude(['folder']).catch('page'),
    parent: z.uuid().optional().catch(undefined),
  }),
  component: function LibraryNewRoute() {
    const search = Route.useSearch();
    return <LibraryNew type={search.type} parentId={search.parent ?? null} />;
  },
});
